export default "__VITE_ASSET__xxAe1FtO__"